export const notificationKeys = {
  all: ["notifications"] as const,
  lists: () => [...notificationKeys.all, "list"] as const,
  list: (params?: Record<string, unknown>) =>
    [...notificationKeys.lists(), params] as const,
  // Prefix-only key (no params slot) — matches every scope variant below,
  // so a broad invalidateQueries call still catches both the merchant
  // (scope=STORE) and admin (scope=SYSTEM) cached unread counts.
  unreadCounts: () => [...notificationKeys.all, "unread-count"] as const,
  unreadCount: (params?: Record<string, unknown>) =>
    [...notificationKeys.unreadCounts(), params] as const,
};
